import { useFormik } from "formik";
import { campoValidationSchema } from "../validation";
import { CampoForm } from "./form";
import { useEffect, useState } from "react";
import { useCampo } from "../hooks/useCampo";
import Swal from "sweetalert2";

export function EditarCampo({ campo, onCancel, onSuccess }) {
  const [isLoading, setIsLoading] = useState(false);
  const { updateCampo } = useCampo();

  const onSubmit = async (values) => {
    console.log(values);
    setIsLoading(true);
    try {
      await updateCampo(campo.idcampo, values);
      Swal.fire({ icon: "success", title: "Cambios guardados", timer: 1500 });
      onSuccess();
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Algo salió mal!",
        text: "Puede que el campo que intentes ingresar ya exista",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const { values, handleChange, handleSubmit, setValues } = useFormik({
    initialValues: {
      campo: "",
      acronimo: "",
      cosecha: "0",
      externo: "0",
    },
    onSubmit,
    validationSchema: campoValidationSchema,
  });

  useEffect(() => {
    if (campo) {
      console.log(campo);
      setValues({
        campo: campo.campo,
        acronimo: campo.acronimo_campo,
        cosecha: campo.in_cosecha ? "1" : "0",
        externo: campo.es_externo ? "1" : "0",
      });
    }
  }, [campo, setValues]);

  return (
    <CampoForm
      values={values}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
      onCancel={onCancel}
      loading={isLoading}
    />
  );
}
